export default __webpack_public_path__ + "static/media/874.e4a4f510.png";